const isLocal =
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1";

export const API_BASE_URL = isLocal
  ? "http://localhost:4000"
  : (process.env.REACT_APP_API_BASE_URL || "");
